import { render } from "./DrawSVGPluginNr2.vue?vue&type=template&id=525f98cc&scoped=true"
import script from "./DrawSVGPluginNr2.vue?vue&type=script&lang=js"
export * from "./DrawSVGPluginNr2.vue?vue&type=script&lang=js"

import "./DrawSVGPluginNr2.vue?vue&type=style&index=0&id=525f98cc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525f98cc"]])

export default __exports__